// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"25abbf7c","167":"7e6dce0b","363":"facd55fc"}[chunkId] + ".chunk.js";
};